import { render } from "./UserNonGtk.vue?vue&type=template&id=662be932"
import script from "./UserNonGtk.vue?vue&type=script&lang=js"
export * from "./UserNonGtk.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__